/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const MenuList = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.MenuList {...otherProps} className={className}>
      {children}
    </components.MenuList>
  );
};

MenuList.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

MenuList.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default MenuList;
